import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { BrandCategoriesStateContext, BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

interface Props extends WidgetProps {}

export interface BrandDetailsLogoStyles {
    container?: InjectableCss;
    image?: LazyImageProps;
    heading?: TypographyProps;
    logoImage?: TypographyProps;
    zoneContainer?: GridContainerProps;
    zoneItem?: GridItemProps;
}

export const logoStyles: BrandDetailsLogoStyles = {
    heading: {
        css: css`
            overflow-wrap: break-word;
            word-wrap: break-word;
        `,
    },
    container: {
        css: css`
            // width: 100%;
            margin: 15px;
        `,
    },
    image: {
        css: css`
            width: 100%;
            img {
                height: 100%;
            }
        `,
    },
    logoImage: {
         css: css`
        max-width: 300px;
        ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                            max-height: unset !important;
                            margin: auto;
                            `,
                            css`
                            max-height: unset !important;
                            margin: auto;
                            `,
                            css`
                            max-height: 100px;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
         `,
        },
        zoneItem: {
            width: 12
        }
};

const styles = logoStyles;

const BrandDetailsLogo: FC<Props> = (props) => {
    const { value: brand } = useContext(BrandStateContext);
    const { value: brandCategories } = useContext(BrandCategoriesStateContext);
    if (!brand) {
        return null;
    }
    return (
        <>
        <StyledWrapper {...styles.container} data-test-selector="brandLogo" 
        {...(brand.logoLargeImagePath ? {...styles.logoImage} : null )}
        > 
            {brand.logoLargeImagePath ? (
                <LazyImage src={brand.logoLargeImagePath} altText={brand.logoAltText} {...styles.image} />
            ) : (
                <Typography data-test-selector="brandLogoHeading" {...styles.heading}>
                    {brand.name}
                </Typography>
            )}
            
        </StyledWrapper>
        <GridContainer {...styles.zoneContainer}>
            <GridItem {...styles.zoneItem}>
                {(!brandCategories || brandCategories.length === 0) && (
                    <Hidden above="sm">
                        <Zone contentId={props.id} zoneName="brandFormHide" />
                    </Hidden>
                )}
            </GridItem>
        </GridContainer>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: BrandDetailsLogo,
    definition: {
        group: "Brand Details",
        icon: "diamond",
        displayName: "Brand Logo",
        allowedContexts: ["BrandDetailsPage"],
    },
};

export default widgetModule;
